import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import store from '../src/redux/store'; 
import Login from '../src/Pages/Login';
import ForgetPassword from './Pages/ForgetPassword';
import ResetPassword from './Pages/ResetPassword';

// Protected pages
import Dashboard from './Pages/SuperAdmin/Dashboard';
import DashboardProvider1 from './Pages/DashboardProvider1';
import StateMaster from './Pages/StateMaster';
import Master from './Pages/Master';
import VisitReason from './Pages/VisitReason';
import DXCode from './Pages/DXCode';
import Facility from './Pages/Facility';
import SuperBill from './Pages/SuperBill';
import TimeSheet from './Pages/TimeSheet';
import Report from './Pages/Report';
import AdminReport from './Pages/SuperAdmin/AdminReport';
import Biller from './Pages/SuperAdmin/Biller';
import Admins from './Pages/SuperAdmin/Admins';
import ProviderPage from './Pages/SuperAdmin/Provider';
import BillerProvider from './Pages/SuperAdmin/BillerProvider';
import Employee from './Pages/SuperAdmin/Employee';
import BillerReport from './Pages/Biller/BillerReport';
import ExcelUpload from './Pages/Provider/ExcelUpload';
import AdminTimeSheet from './Pages/SuperAdmin/TimeSheet';
import BillerTimeSheet from './Pages/BillerTimeSheet';
import ProtectedLayout from './ProtectedLayout';
import NotFound from './Pages/NotFound';

// Matches Sidebar2 AdminRoutes (exclusive of SubAdminRoutes)
const SUPER_ADMIN_ROLES = ['Admin'];

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/forgot-password/:id/:id" element={<ResetPassword />} />

          {/* Shared admin-family routes (Admin + Finance + Operations) */}
          <Route
            path="/dashboard"
            element={
              <ProtectedLayout>
                <Dashboard />
              </ProtectedLayout>
            }
          />
          <Route
            path="/admin-report"
            element={
              <ProtectedLayout>
                <AdminReport />
              </ProtectedLayout>
            }
          />
          <Route
            path="/admin/timesheet"
            element={
              <ProtectedLayout>
                <AdminTimeSheet />
              </ProtectedLayout>
            }
          />

          {/* Super Admin only — mirrors Sidebar2 AdminRoutes */}
          <Route
            path="/state-master"
            element={
              <ProtectedLayout roles={SUPER_ADMIN_ROLES}>
                <StateMaster />
              </ProtectedLayout>
            }
          />
          <Route
            path="/facility-type-master"
            element={
              <ProtectedLayout roles={SUPER_ADMIN_ROLES}>
                <Master />
              </ProtectedLayout>
            }
          />
          <Route
            path="/visit-reason"
            element={
              <ProtectedLayout roles={SUPER_ADMIN_ROLES}>
                <VisitReason />
              </ProtectedLayout>
            }
          />
          <Route
            path="/dx-code"
            element={
              <ProtectedLayout roles={SUPER_ADMIN_ROLES}>
                <DXCode />
              </ProtectedLayout>
            }
          />
          <Route
            path="/facility"
            element={
              <ProtectedLayout roles={SUPER_ADMIN_ROLES}>
                <Facility />
              </ProtectedLayout>
            }
          />
          <Route
            path="/biller"
            element={
              <ProtectedLayout roles={SUPER_ADMIN_ROLES}>
                <Biller />
              </ProtectedLayout>
            }
          />
          <Route
            path="/admins-user"
            element={
              <ProtectedLayout roles={SUPER_ADMIN_ROLES}>
                <Admins />
              </ProtectedLayout>
            }
          />
          <Route
            path="/provider"
            element={
              <ProtectedLayout roles={SUPER_ADMIN_ROLES}>
                <ProviderPage />
              </ProtectedLayout>
            }
          />
          <Route
            path="/biller-provider"
            element={
              <ProtectedLayout roles={SUPER_ADMIN_ROLES}>
                <BillerProvider />
              </ProtectedLayout>
            }
          />
          <Route
            path="/employee"
            element={
              <ProtectedLayout roles={SUPER_ADMIN_ROLES}>
                <Employee />
              </ProtectedLayout>
            }
          />

          {/* Provider / Biller / Employee app routes */}
          <Route
            path="/providerdashboard"
            element={
              <ProtectedLayout>
                <DashboardProvider1 />
              </ProtectedLayout>
            }
          />
          <Route
            path="/superbill"
            element={
              <ProtectedLayout>
                <SuperBill />
              </ProtectedLayout>
            }
          />
          <Route
            path="/timesheet"
            element={
              <ProtectedLayout>
                <TimeSheet />
              </ProtectedLayout>
            }
          />
          <Route
            path="/report"
            element={
              <ProtectedLayout>
                <Report />
              </ProtectedLayout>
            }
          />
          <Route
            path="/biller-dashboard"
            element={
              <ProtectedLayout>
                <BillerReport />
              </ProtectedLayout>
            }
          />
          <Route
            path="/excel-upload"
            element={
              <ProtectedLayout>
                <ExcelUpload />
              </ProtectedLayout>
            }
          />
          <Route
            path="/biller/timesheet"
            element={
              <ProtectedLayout>
                <BillerTimeSheet />
              </ProtectedLayout>
            }
          />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
